export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    storeVehicle() {
      return this.$store.state.vehicles.set.storeVehicle
    },
    datesAndBusinessReady() {
      return this.$store.getters['booking/datesAndBusinessReady']
    },
    canGoToQuotation() {
      return this.storeVehicle && this.datesAndBusinessReady
    },
  },
  methods: {
    onSelect() {
      this.$store.commit('booking/SET_PICKUP_BUSINESS', this.business)
      this.loading = true
      if (this.canGoToQuotation) {
        this.$store.commit('stepping/SET_CURRENT_STEP', 1)
        return this.$store.dispatch('stepping/VALIDATE_STEP_1')
      }
      this.$store.commit('stepping/TRIGGER_STEP_NAVIGATION', { step: 0 })
    },
  },
}
